import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

/**
 * The expiry filters of the Allegati view, in the order the chips show them.
 * `valore` is what the server takes as `scadenza`; `ordine` is the direction of
 * the expiry sort the list switches to with the preset, so that what is about
 * to expire, or has just expired, comes first; `vuoto` says what an empty
 * answer means.
 */
export const PRESET_SCADENZA = [
  {
    valore: 'IN_SCADENZA_30',
    etichetta: 'In scadenza (30 gg)',
    ordine: 'ASC',
    vuoto: 'Nessun documento scade nei prossimi 30 giorni.',
  },
  {
    valore: 'IN_SCADENZA_7',
    etichetta: 'In scadenza (7 gg)',
    ordine: 'ASC',
    vuoto: 'Nessun documento scade nei prossimi 7 giorni.',
  },
  {
    valore: 'SCADUTI_30',
    etichetta: 'Scaduti da 30 gg',
    ordine: 'DESC',
    vuoto: 'Nessun documento è scaduto negli ultimi 30 giorni.',
  },
  {
    valore: 'SCADUTI',
    etichetta: 'Tutti gli scaduti',
    ordine: 'DESC',
    vuoto: 'Nessun documento è scaduto.',
  },
];

export const trovaPreset = (valore) =>
  PRESET_SCADENZA.find((preset) => preset.valore === valore) ?? null;

/**
 * Calendar days from today to the expiry day, both read where the panel is
 * open: `0` on the expiry day itself, negative once it has passed, `null` when
 * there is no readable date. Calendar days and not elapsed time, so an expiry
 * saved as local midnight and one saved as UTC midnight count the same, and a
 * change of daylight saving time in between moves nothing.
 */
export const giorniAllaScadenza = (dataScadenza, oggi = new Date()) => {
  if (!dataScadenza) return null;
  const giorno = new Date(dataScadenza);
  if (Number.isNaN(giorno.getTime())) return null;
  return differenceInCalendarDays(giorno, oggi);
};

/**
 * The tier an expiry falls in, the same thresholds as the app's badge: the
 * expiry day is still valid («Scade oggi») and the document reads as expired
 * from the next day.
 */
export const fasciaScadenza = (giorni) => {
  if (giorni == null) return null;
  if (giorni < 0) return 'scaduto';
  if (giorni === 0) return 'oggi';
  if (giorni <= 15) return 'entro15';
  if (giorni <= 30) return 'entro30';
  return 'oltre30';
};

/**
 * The words beside the date on the pill, so that the tier is told by more than
 * its colour. Nothing past 30 days: the date alone says all there is.
 */
export const statoScadenza = (giorni) => {
  const fascia = fasciaScadenza(giorni);
  if (fascia === 'scaduto') return 'Scaduto';
  if (fascia === 'oggi') return 'Scade oggi';
  if (giorni === 1) return 'Domani';
  if (fascia === 'entro15' || fascia === 'entro30') return `Tra ${giorni} gg`;
  return null;
};

/**
 * Where a document of the flat list sits: `percorsoCartella` runs from the root
 * to the document's own folder, at most two levels, and is empty at the root.
 */
export const descriviPercorso = (percorsoCartella) =>
  Array.isArray(percorsoCartella) && percorsoCartella.length > 0
    ? percorsoCartella.map((cartella) => cartella.nome).join(' / ')
    : '—';
